import {
    addToTrace,
    newTrace
} from '../services/helperFunctions'

/**
 * 
 * @param {array} nums Array of number to be sorted and traced
 */
const InsertionSort = (nums) => {
    // Initial State
    const trace = newTrace(nums);

    // Core Algorithm
    for (let i = 1; i < nums.length; i++) {
        let value = nums[i];
        let hole = i;
        // Visualize: Hole has been selected for comparison
        addToTrace(trace, nums, [], [i]);
        while (hole > 0 && nums[hole - 1] > value) {
            // Visualize: Compare hole to value
            addToTrace(trace, nums, [], [hole], [hole - 1]);
            nums[hole] = nums[hole - 1];
            hole -= 1;
            // Visualize: Overwrite hole with hole - 1
            addToTrace(trace, nums, [], [], [hole, hole + 1]);
        }
        // Visualize: Overwrite hole with value
        addToTrace(trace, nums, [], [], [], [hole]);
        nums[hole] = value;
        // Visualize: value is in sorted position
        addToTrace(trace, nums, [], [], [], [hole]);
    }

    // Visualize: Mark all elements as sorted
    addToTrace(trace, nums, [...Array(nums.length).keys()]);
    return trace;
};

export default InsertionSort;